import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { useCallback, useState } from "react";
import Navaids from "../layers/Navaids";
import { makeStyles } from "@material-ui/core/styles";
import ndbImg from "../../../images/contents/map/navaids/NDB.png";
import tacanImg from "../../../images/contents/map/navaids/TACAN.png"
import vorImg from "../../../images/contents/map/navaids/VOR.png"
import vorDmeImg from "../../../images/contents/map/navaids/VOR_DME.png"
import vorTacImg from "../../../images/contents/map/navaids/VOR_TAC.png"

const useStyles = makeStyles(() => ({
  checkLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12
  }
}));

function LegendNavaids({contents: navaids}) {
  const classes = useStyles();
  const [contentsState, setContentsState] = useState(navaids.getContentsVisibleState());

  const toggleContents = useCallback(event => {
    navaids.setVisible(event.target.checked, event.target.name);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [navaids, contentsState]);

  return (
    <div>
    <FormGroup>
      <FormControlLabel
        control={<Checkbox checked={contentsState[Navaids.VOR_NAME]} onChange={toggleContents} name={Navaids.VOR_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={vorImg} alt="VOR"/>
            VOR
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Navaids.VOR_DME_NAME]} onChange={toggleContents} name={Navaids.VOR_DME_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={vorDmeImg} alt="VOR/DME"/>
            VOR/DME
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Navaids.VOR_TAC_NAME]} onChange={toggleContents} name={Navaids.VOR_TAC_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={vorTacImg} alt="VOR/TAC"/>
            VOR/TAC
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Navaids.TACAN_NAME]} onChange={toggleContents} name={Navaids.TACAN_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={tacanImg} alt="TACAN"/>
            TACAN
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Navaids.NDB_NAME]} onChange={toggleContents} name={Navaids.NDB_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={ndbImg} alt="NDB"/>
            NDB
          </span>
        }
      />
    </FormGroup>
    </div>
  )
}

export default LegendNavaids;